import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonNote,
  IonTitle,
  IonToolbar,
  IonThumbnail,
  modalController
} from '@ionic/vue';
import { Actions, hasPermission } from '@/authorization'
import { arrowBackOutline } from 'ionicons/icons';
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex'
import { DxpShopifyImg, translate, getProductIdentificationValue, useProductIdentificationStore } from '@hotwax/dxp-components';
import { getFeatures } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReceiveTransferOrder',
  props: ["closeTO", "items", "receivedUnitsFraction"],
  setup(__props) {

const store = useStore()
const productIdentificationStore = useProductIdentificationStore();

const getProduct = computed(() => (id: any) => store.getters["product/getProduct"](id));
const isReceivingByFulfillment = computed(() => store.getters["util/isReceivingByFulfillment"])
const getOverReceivedQtyForItem = computed(() => (item: any): number => ((Number(item.totalReceivedQuantity) || 0) + (Number(item.quantityAccepted) || 0) - getItemQty(item)))
let productIdentificationPref = computed(() => productIdentificationStore.getProductIdentificationPref)
const saveButtonLabel = computed(() => props.closeTO ? translate("Complete transfer order") : canReceiveAndClose() ? translate("Receive and complete") : translate("Save progress"))

let validTOItems = ref([])
let overReceivedTOItems: any = ref([])
let itemsToComplete: any = ref([])
let receivedQty: any = ref(0)

const props = __props

onMounted(() => {
  validTOItems.value = props.items?.filter((item: any) => !['ITEM_REJECTED', 'ITEM_CANCELLED', 'ITEM_COMPLETED'].includes(item.statusId))
  // Mark all items as completed for which user has entered any qty, this will be equal to all the open items
  itemsToComplete.value = validTOItems.value.filter((item: any) => props.closeTO ? item.quantityAccepted >= 0 : item.quantityAccepted > 0)

  if(props.closeTO) {
    overReceivedTOItems.value = itemsToComplete.value.filter((item: any) => ((Number(item.totalReceivedQuantity) || 0) + (Number(item.quantityAccepted) || 0)) != getItemQty(item))
  } else {
    overReceivedTOItems.value = itemsToComplete.value.filter((item: any) => ((Number(item.totalReceivedQuantity) || 0) + (Number(item.quantityAccepted) || 0)) > getItemQty(item))
  }

  receivedQty.value = itemsToComplete.value.reduce((qty: any, item: any) => qty + (Number(item.quantityAccepted) || 0), 0)
})

function canReceiveAndClose() {
  return validTOItems.value.every((item: any) => {
    const totalReceived = (Number(item.totalReceivedQuantity) || 0) + (Number(item.quantityAccepted) || 0)
    return totalReceived >= getItemQty(item)
  })
}

function getItemQty(item: any) {
  return (isReceivingByFulfillment.value ? item.totalIssuedQuantity : item.quantity) || 0
}

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

function saveProgress() {
  modalController.dismiss({ updateItems: true });
}

function isEligibleToCloseTOItems() {
  return overReceivedTOItems.value.every((item: any) => item.isChecked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  "data-testid": "transfer-order-receive-modal-close-btn",
                  onClick: closeModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(arrowBackOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.closeTO)
              ? (_openBlock(), _createBlock(_unref(IonTitle), {
                  key: 0,
                  "data-testid": "transfer-order-receive-modal-complete-title"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Complete transfer order")), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonTitle), {
                  key: 1,
                  "data-testid": "transfer-order-receive-modal-save-progress-title"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Save receiving progress")), 1)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { "data-testid": "transfer-order-receive-modal-content" }, {
      default: _withCtx(() => [
        (!__props.closeTO)
          ? (_openBlock(), _createBlock(_unref(IonItem), {
              key: 0,
              "data-testid": "transfer-order-receive-modal-progress-info-section",
              lines: "full"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), {
                  innerHTML: _unref(translate)('Your receiving progress will be saved and will be added to your inventory. Come back to this transfer order and finish receiving later. Fully received items auto close.', { space: '<br /><br />', units: __props.receivedUnitsFraction })
                }, null, 8, ["innerHTML"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonItem), {
          "data-testid": "transfer-order-receive-modal-discrepancy-summary-section",
          lines: "none"
        }, {
          default: _withCtx(() => [
            (__props.closeTO)
              ? (_openBlock(), _createBlock(_unref(IonListHeader), {
                  key: 0,
                  "data-testid": "transfer-order-receive-modal-close-summary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("out of items were not received as expected. Please verify them before closing the transfer order", { totalItems: _unref(itemsToComplete).length, items: _unref(overReceivedTOItems).length })), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonListHeader), {
                  key: 1,
                  "data-testid": "transfer-order-receive-modal-save-summary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("of items was over received or not expected. Please verify them before saving progress", { totalItems: _unref(itemsToComplete).length, items: (_unref(overReceivedTOItems).length || 0) })), 1)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonList), { "data-testid": "transfer-order-receive-modal-discrepancy-list" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(overReceivedTOItems), (item, index) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                key: index,
                "data-testid": `transfer-order-receive-modal-discrepancy-row-${item.orderItemSeqId || item.productId}`,
                onClick: ($event: any) => ((item.isChecked = !item.isChecked))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonThumbnail), { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxpShopifyImg), {
                        size: "small",
                        src: getProduct.value(item.productId).mainImageUrl
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(_unref(getProductIdentificationValue)(_unref(productIdentificationPref).primaryId, getProduct.value(item.productId)) ? _unref(getProductIdentificationValue)(_unref(productIdentificationPref).primaryId, getProduct.value(item.productId)) : getProduct.value(item.productId).productName), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(getProductIdentificationValue)(_unref(productIdentificationPref).secondaryId, getProduct.value(item.productId))), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(getFeatures)(getProduct.value(item.productId).productFeatures)), 1),
                      (item.orderItemSeqId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!__props.closeTO)
                              ? (_openBlock(), _createBlock(_unref(IonNote), {
                                  key: 0,
                                  color: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(translate)("Over received:")) + " " + _toDisplayString(getOverReceivedQtyForItem.value(item)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_unref(IonNote), {
                                  key: 1,
                                  color: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getOverReceivedQtyForItem.value(item) > 0 ? _unref(translate)("Over received:") : _unref(translate)("Under received:")) + " " + _toDisplayString(getOverReceivedQtyForItem.value(item)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ], 64))
                        : (_openBlock(), _createBlock(_unref(IonNote), {
                            key: 1,
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("Not expected:")) + " " + _toDisplayString(getOverReceivedQtyForItem.value(item)), 1)
                            ]),
                            _: 2
                          }, 1024))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(IonCheckbox), {
                    slot: "end",
                    "data-testid": `transfer-order-receive-modal-discrepancy-checkbox-${item.orderItemSeqId || item.productId}`,
                    modelValue: item.isChecked
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonNote), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("report discrepancy")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["data-testid", "modelValue"])
                ]),
                _: 2
              }, 1032, ["data-testid", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "ion-padding-start" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { slot: "start" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Select all items to proceed")), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  "data-testid": "transfer-order-receive-modal-save-btn",
                  fill: "solid",
                  color: "primary",
                  disabled: !_unref(hasPermission)(_unref(Actions).APP_SHIPMENT_UPDATE) || !isEligibleToCloseTOItems(),
                  onClick: saveProgress
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(saveButtonLabel.value), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})